import { type GetEnvironmentsByProjectQueryParams } from '@gonfalon/openapi/operations/getEnvironmentsByProject';
import { useQuery } from '@tanstack/react-query';

import { getEnvironmentsByProjectQuery } from '../queries/environments';

export const useEnvironments = ({
  projectKey,
  params,
}: {
  projectKey: string;
  params?: GetEnvironmentsByProjectQueryParams;
}) => {
  return useQuery(getEnvironmentsByProjectQuery({ projectKey, query: params }));
};
